// extracted by mini-css-extract-plugin
export default {"root":"OperationsPaymentDetails_root__+KgTM"};